import {
  contactResponseSchema,
  type ContactRequest,
  type ContactResponse,
} from "@general-applications/contracts";

const networkError: ContactResponse = {
  ok: false,
  code: "network_error",
  error: "Could not reach the server. Check your connection and try again.",
};

export async function submitContactForm(
  payload: ContactRequest,
): Promise<ContactResponse> {
  try {
    const res = await fetch("/api/contact", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    const json: unknown = await res.json();
    // Parsed, not just cast — a body that doesn't match the contract (a
    // proxy error page, a future server bug) falls back to networkError
    // instead of the UI trusting a shape that was never actually checked.
    const parsed = contactResponseSchema.safeParse(json);
    return parsed.success ? parsed.data : networkError;
  } catch {
    return networkError;
  }
}
